import { doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove, increment } from 'firebase/firestore';
import { db } from '../firebase';

// Like a user profile (only once per user)
export const likeUserProfile = async (profileUid, likerUid) => {
  if (!profileUid || !likerUid || profileUid === likerUid) return;
  const profileRef = doc(db, 'users', profileUid);
  const likeDocRef = doc(db, 'users', profileUid, 'likes', likerUid);

  // Check if already liked
  const likeDoc = await getDoc(likeDocRef);
  if (likeDoc.exists()) return { alreadyLiked: true };

  // Add like
  await setDoc(likeDocRef, { likedAt: new Date().toISOString() });
  await updateDoc(profileRef, { likes: increment(1) });
  return { success: true };
};

// Unlike a user profile
export const unlikeUserProfile = async (profileUid, likerUid) => {
  if (!profileUid || !likerUid || profileUid === likerUid) return;
  const profileRef = doc(db, 'users', profileUid);
  const likeDocRef = doc(db, 'users', profileUid, 'likes', likerUid);

  // Check if like exists
  const likeDoc = await getDoc(likeDocRef);
  if (!likeDoc.exists()) return { notLiked: true };

  // Remove like
  await setDoc(likeDocRef, {});
  await updateDoc(profileRef, { likes: increment(-1) });
  return { success: true };
};

// Check if a user has liked a profile
export const hasUserLikedProfile = async (profileUid, likerUid) => {
  if (!profileUid || !likerUid) return false;
  const likeDocRef = doc(db, 'users', profileUid, 'likes', likerUid);
  const likeDoc = await getDoc(likeDocRef);
  return likeDoc.exists();
};
